import { render, staticRenderFns } from "./ActivityChallenge.vue?vue&type=template&id=23a7d4df"
import script from "./ActivityChallenge.vue?vue&type=script&lang=js"
export * from "./ActivityChallenge.vue?vue&type=script&lang=js"
import style0 from "./ActivityChallenge.vue?vue&type=style&index=0&id=23a7d4df&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports